import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as registrationActions from '../../actions/registrationActions';
import { push } from 'connected-react-router';
import { Container, Grid, Button, Header } from 'semantic-ui-react';

class ConfirmEmailPage extends Component {
	constructor(props) {
		super(props);

		const query = new URLSearchParams(this.props.location.search);
		const code = query.get("code");
		const userId = query.get("userId");

		this.state = {
			confirmed: false,
			code: code,
			userId: userId
		};

		this.props.actions.confirmEmail({ code, userId });
		this.onLoginClick = this.onLoginClick.bind(this);
	}

	onLoginClick() {
		this.props.actions.push('/');
	}

	render() {
		return (
			<div className='auth login'>
				<Container>
					<Grid columns='equal'>
						<Grid.Column width={7} only='tablet computer' />
						<Grid.Column computer={8} mobile={16} tablet={8}>
							<Header as='h2' content='Thank you for confirming your email address.' />
							<div className='row-center'>
								<Button primary onClick={this.onLoginClick}>
									Login
								</Button>
							</div>
						</Grid.Column>
					</Grid>
				</Container>
			</div>
		);
	}
}

ConfirmEmailPage.propTypes = {
	actions: PropTypes.object.isRequired,
	location: PropTypes.object.isRequired
};

const mapStateToProps = (state, ownProps) => {
	return {};
};

const mapDispatchToProps = (dispatch, ownProps) => {
	return {
		actions: {
			...bindActionCreators(registrationActions, dispatch),
			...bindActionCreators({ push }, dispatch)
		}
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(ConfirmEmailPage);
